(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-blog"] && !Shopify.designMode) return;
  try {
      
document.querySelectorAll('[id^="shopify-section-"]').forEach((card, index) => {
   console.log = function(){};
   if(card.classList.contains('featured-blog')) {     
    const topHeading = card.querySelectorAll('.for-arrow-alignment');        
    const cardHeight = parseInt(topHeading[0].clientHeight);
    const topValue = cardHeight / 2 + 5;
    const cardTopCSS = "calc(50% - "+topValue+'px)';     
    const swiperContainer = card.querySelector('.swiper');    
     if(!swiperContainer) return;
    const swiperPrevElement = swiperContainer.querySelector('.swiper-button-prev');    
    const swiperNextElement = swiperContainer.querySelector('.swiper-button-next');     
    if(!swiperPrevElement || !swiperNextElement) return
    swiperPrevElement.setAttribute('style', 'top:'+cardTopCSS);    
    swiperNextElement.setAttribute('style', 'top:'+cardTopCSS);
  }        
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      // this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    // closeSearchModal() {
    //   this.searchModal = this.searchModal || this.header.querySelector('details-modal');
    //   this.searchModal.close(false);
    // }
  }

  customElements.define('sticky-header', StickyHeader);
        
        
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      /* Null guard — when localization form has no button (single-locale shops or restructured header) */
      if (!this.elements.button) return;
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);



  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["limsa-product-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs(root) {
    if (root.dataset.limsaInit === '1') return;
    root.dataset.limsaInit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-limsa-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-limsa-panel]'));
    if (!tabs.length) return;
    function activate(idx) {
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-limsa-tab') === idx;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-limsa-panel') === idx;
        p.classList.toggle('is-active', on);
        if (on) { p.removeAttribute('hidden'); } else { p.setAttribute('hidden', ''); }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-limsa-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        var n = e.key === 'ArrowRight' ? i + 1 : i - 1;
        if (n < 0) n = tabs.length - 1;
        if (n >= tabs.length) n = 0;
        tabs[n].focus();
        activate(tabs[n].getAttribute('data-limsa-tab'));
      });
    });
  }
  function initAll() {
    var roots = document.querySelectorAll('[data-limsa-ptabs]');
    Array.prototype.forEach.call(roots, initTabs);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  /* LIMSA 2026-04-18 patch: null-safe + mobile'da çökmez + loaded class her durumda eklenir */
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      var self = this;

      function loadRecs() {
        fetch(self.dataset.url)
          .then(function(response){ return response.text(); })
          .then(function(text){
            var html = document.createElement('div');
            html.innerHTML = text;
            var recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              self.innerHTML = recommendations.innerHTML;

              /* jQuery-safe loading-image cleanup */
              try {
                var loadings = self.querySelectorAll('.loading-image');
                loadings.forEach(function(n){
                  n.classList.remove('loading-image');
                  n.classList.add('loaded-image');
                });
              } catch(e){}

              /* Swiper prev/next konumlandırma — null-safe */
              try {
                var sameCard = self.querySelector('.from-recommended');
                var swiperContainer = self.querySelector('.swiper');
                if (sameCard && swiperContainer) {
                  var cardHeight = parseInt(sameCard.clientHeight, 10) || 0;
                  if (cardHeight > 0) {
                    var topValue = cardHeight / 2 + 5;
                    var cardTopCSS = 'calc(50% - ' + topValue + 'px)';
                    var prev = swiperContainer.querySelector('.swiper-button-prev');
                    var next = swiperContainer.querySelector('.swiper-button-next');
                    if (prev) prev.setAttribute('style', 'top:' + cardTopCSS);
                    if (next) next.setAttribute('style', 'top:' + cardTopCSS);
                  }
                }
              } catch(e){ /* navigation yoksa sessiz geç */ }
            }

            /* Loaded class'ı her durumda ekle (grid__item, card-wrapper, swiper-slide VEYA img varsa) */
            if (self.querySelector('.grid__item, .card-wrapper, .swiper-slide, img')) {
              self.classList.add('product-recommendations--loaded');
            }
            self.classList.add('limsa-recs-ready');
            self.removeAttribute('hidden');
          })
          .catch(function(e){
            /* Hata olsa bile section görünür kalsın */
            self.classList.add('product-recommendations--loaded', 'limsa-recs-ready');
          });
      }

      /* Intersection tetikleyici */
      try {
        new IntersectionObserver(function(entries, observer){
          if (!entries[0].isIntersecting) return;
          observer.unobserve(self);
          loadRecs();
        }, { rootMargin: '0px 0px 400px 0px' }).observe(this);
      } catch(e) {
        loadRecs();
      }

      /* Mobile fallback: 1.2s sonra hala boşsa direkt fetch */
      setTimeout(function(){
        if (self.innerHTML.trim().length < 200 && !self.classList.contains('limsa-recs-ready')) {
          loadRecs();
        }
      }, 1200);
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();
})();
